module.exports = __webpack_public_path__ + "static/media/delantal (4).1fd2e611.jpg";